import { fork, put, takeLatest } from 'redux-saga/effects';
import { getType } from '../../utils';
import actions from './actions';
export function* deleteUserRedeemReward(api, action) {
    const { userId, rewardId } = action.payload;
    try {
        yield api
            .deleteUserRedeemFromReward({
            userId,
            rewardId,
        })
            .then((p) => p.request);
        yield put(actions.deleteUserRedeemRewardSuccess(userId));
    }
    catch (error) {
        yield put(actions.deleteUserRedeemRewardError(error));
    }
}
export function* watchDeleteUserRedeemReward(api) {
    yield takeLatest(getType(actions.deleteUserRedeemReward), deleteUserRedeemReward, api);
}
export const userRewardsSagas = (api) => [
    fork(watchDeleteUserRedeemReward, api),
];
export default userRewardsSagas;
